import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#F2F4F7",
      d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16Z"
    }, null, -1 /* HOISTED */),
    _createElementVNode("path", {
      fill: "#344054",
      "fill-rule": "evenodd",
      d: "M15.698 7.889a1.5 1.5 0 0 1 .604 0c.23.047.437.162.6.254l.045.025 5.55 3.084.047.026c.174.095.392.215.56.397a1.5 1.5 0 0 1 .32.546c.078.234.077.483.076.681V19.098c0 .198.002.447-.076.681a1.5 1.5 0 0 1-.32.546c-.168.182-.386.302-.56.397-.016.01-.032.018-.047.026l-5.55 3.084-.045.025c-.163.091-.37.207-.6.254a1.5 1.5 0 0 1-.604 0c-.23-.047-.437-.163-.6-.254a6.47 6.47 0 0 0-.045-.025l-5.55-3.084a15.024 15.024 0 0 0-.047-.026c-.174-.095-.392-.215-.559-.397a1.5 1.5 0 0 1-.321-.546c-.078-.234-.077-.483-.076-.681V12.902c0-.198-.002-.447.076-.681a1.5 1.5 0 0 1 .321-.546c.167-.182.385-.302.559-.397l.047-.027 5.55-3.083.045-.025c.163-.092.37-.207.6-.254ZM16 9.362a4.998 4.998 0 0 0-.219.118l-4.987 2.77L16 15.142l5.206-2.892-4.987-2.77A4.919 4.919 0 0 0 16 9.361Zm6 4.163v5.519c0 .137 0 .207-.003.258v.005a5.07 5.07 0 0 1-.228.13l-5.019 2.788v-5.784L22 13.525Zm-6.75 2.916L10 13.525v5.519c0 .137 0 .207.003.258v.005l.004.002c.043.027.104.062.225.128l5.018 2.788v-5.784Z",
      "clip-rule": "evenodd"
    }, null, -1 /* HOISTED */)
  ])))
}
export default { render: render }